import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutCommunityMetricConfig } from 'src/environments/environment.interface';

@Component({
  selector: 'app-about-community-metric-card',
  standalone: false,
  templateUrl: './about-community-metric-card.component.html',
  styleUrls: ['./about-community-metric-card.component.scss']
})
export class AboutCommunityMetricCardComponent {
  @Input() metric: AboutCommunityMetricConfig | null = null;
}
